import { IntercomScreen } from '@getstep/sdk/dist/store/intercom/Screens'
import type { FunctionComponent } from 'react'
import { memo, useEffect } from 'react'
import { InView } from 'react-intersection-observer'

import { helpCenterStore } from '@lib/store/ui/help-center'

export const useHelpCenterScreen = (screen: IntercomScreen) => {
    useEffect(() => {
        helpCenterStore.setScreen(screen)
        return () => helpCenterStore.setScreen(IntercomScreen.HOME)
    }, [screen])
}

export const HelpCenterScreenWhenInView: FunctionComponent<
    React.PropsWithChildren<{
        screen: IntercomScreen
    }>
> = memo(({ screen, children }) => (
    <InView onChange={() => helpCenterStore.setScreen(screen)}>
        {children}
    </InView>
))
